import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-4xl"
}
const _hoisted_2 = {
  key: 0,
  class: "relative my-8"
}
const _hoisted_3 = { class: "relative flex justify-center" }
const _hoisted_4 = { class: "rounded-full px-2 py-1 text-xxs leading-3 font-manrope uppercase tracking-wider bg-gray-400 text-white" }
const _hoisted_5 = {
  key: 1,
  class: "my-4 mx-10 md:mx-20"
}

import { computed } from 'vue'

import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'ConversationItem',
  props: { item: { type: Object, required: true }, previousItem: { type: Object, required: false } },
  setup(__props) {

const props = __props

const child = computed(() => {
  const rels = Object.values(props.item.relationships).filter(x => x.data.type !== 'conversation')
  console.assert(rels.length === 1, 'one child item on a conversation item')
  return mapRelationship(rels[0].data)
})

const isDifferentType = computed(
  () => props.item?.attributes.child_class_name !== props.previousItem?.attributes.child_class_name
)

const dateFormat = new Intl.DateTimeFormat([], { dateStyle: 'medium' })
const formattedCreatedAt = computed(() => {
  if (!props.item?.attributes.created_at) return null
  const created = new Date(props.item.attributes.created_at)
  return created.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
})
const itemCreatedAt = computed(() => {
  if (!props.item?.attributes.created_at) return null
  const created = new Date(props.item.attributes.created_at)
  return dateFormat.format(created)
})
const previousItemCreatedAt = computed(() => {
  if (!props.previousItem?.attributes.created_at) return null
  const created = new Date(props.previousItem.attributes.created_at)
  return dateFormat.format(created)
})

const isDifferentDay = computed(() => itemCreatedAt.value !== previousItemCreatedAt.value)

return (_ctx, _cache) => {
  const _component_message_card = _resolveComponent("message-card")
  const _component_call_card = _resolveComponent("call-card")
  const _component_activity_card = _resolveComponent("activity-card")

  return (child.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isDifferentDay.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", {
                class: "absolute inset-0 flex items-center",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "w-full border-t border-gray-300" })
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(formattedCreatedAt.value), 1)
              ])
            ]))
          : (isDifferentType.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true),
        (child.value.type === 'message')
          ? (_openBlock(), _createBlock(_component_message_card, {
              key: 2,
              message: child.value
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        (child.value.type === 'call')
          ? (_openBlock(), _createBlock(_component_call_card, {
              key: 3,
              call: child.value
            }, null, 8, ["call"]))
          : _createCommentVNode("", true),
        (child.value.type === 'activity')
          ? (_openBlock(), _createBlock(_component_activity_card, {
              key: 4,
              activity: child.value
            }, null, 8, ["activity"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

}